
import { Component, Mixins } from 'vue-property-decorator';
import HomeSlider from './';
@Component
export default class HomeSliderEn extends Mixins(HomeSlider) {}
